import type { DomainConfig } from "../domain.types";

export const domainConfig = {
  hostname: "www.ranking-expert.ca",
  region: "ca",
  language: "en",
  vertical: "best",
  brand: {
    name: "Ranking expert",
    logoSrc: "/domains/ranking-expert/logo.svg",
    faviconSrc: "/domains/ranking-expert/logo.svg",
  },
  contact: {
    fromAddress: "support@exon-media.com",
    toAddress: "support@exon-media.com",
    partnershipsAddress: "partnerships@exon-media.com",
  },
  privacy: {
    email: "privacy@ranking-expert.ca",
  },
  footer: {
    popularPages: [
      {
        label: "Best Air Fryers",
        href: "/best/home-garden/deep-fryers/air%20fryer",
      },
      {
        label: "Best Robot Vacuums",
        href: "/best/home-garden/vacuums/vacuum%20robot",
      },
      {
        label: "Best Laptops",
        href: "/best/electronics/laptops/laptops",
      },
      {
        label: "Best Espresso Machines",
        href: "/best/home-garden/coffee-makers-espresso-machines/espresso%20machines",
      },
      {
        label: "Best Air Purifier",
        href: "/best/home-garden/air-purifiers/air%20purifier",
      },
      {
        label: "Best Cooling Neck Fans",
        href: "/best/electronics/computer-system-cooling-parts/cooling%20neck%20fans",
      },
    ],
  },
} satisfies DomainConfig;
